import React from "react";
import { useTranslation } from "react-i18next";
import { AddCrossTinyIcon, Header2, IconButton, Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";

export const CalendarCreateTask = ({ canCreate, onOpenModal = () => null }) => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-w-full tw-h-10 tw-items-center tw-justify-between">
      <Header2>{t("Tasks")}</Header2>

      {canCreate ? (
        <IconButton
          variant="option"
          onClick={onOpenModal}
        >
          <Tooltip title={t("New Task")}>
            <AddCrossTinyIcon />
          </Tooltip>
        </IconButton>
      ) : null}
    </div>
  );
};

CalendarCreateTask.propTypes = {
  canCreate: PropTypes.bool,
  onOpenModal: PropTypes.func,
};
